var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"description":"Maak hier een koppeling met het onderdeel uit de oude prognose"}},[_c('b-form-text',[_vm._v("Import onderdeel")]),_c('b-select',{attrs:{"options":_vm.onderdelen,"value":_vm.value},on:{"change":_vm.setValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }